// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Login_errorMessage__GhMNN","socialButtons":"Login_socialButtons__2eVBg","icon":"Login_icon__3twrb"};